import { Accordion, InputField, SelectField } from '@ubeya/shared-web/components';
import React, { useContext } from 'react';
import ConfigContext from '@ubeya/shared-web/contexts/ConfigContext';
import { FieldsContainer, SectionContent } from '../styled';

const BankDetails = () => {
  const { t } = useContext(ConfigContext);

  return (
    <Accordion defaultOpenRows={{ 0: true }}>
      <Accordion.Item title={t('invoicingSettings__bankDetails')}>
        <SectionContent>
          <FieldsContainer $count={2}>
            <InputField name="invoicing.bankCountry" title={t('invoicingSettings__bankCountry')} />
            <InputField name="invoicing.bankName" title={t('invoicingSettings__bankName')} />
            <InputField name="invoicing.bankAccountName" title={t('invoicingSettings__bankAccountName')} />
            <InputField name="invoicing.bankSortCode" title={t('invoicingSettings__bankSortCode')} />
            <InputField name="invoicing.bankAccountNumber" title={t('invoicingSettings__bankAccountNumber')} />
            <SelectField
              name="invoicing.bankPaymentTerms"
              title={t('invoicingSettings__bankPaymentTerms')}
              isMulti={false}
              options={[
                { label: t('invoicingSettings__immediate'), value: 'immediate' },
                { label: t('invoicingSettings__in_15_days'), value: '15' },
                { label: t('invoicingSettings__in_30_days'), value: '30' },
                { label: t('invoicingSettings__in_60_days'), value: '60' },
                { label: t('invoicingSettings__in_90_days'), value: '90' },
                { label: t('invoicingSettings__due_on_receipt'), value: 'dor' },
                { label: t('invoicingSettings__eom_(end_of_month)'), value: 'eom' }
              ]}
            />
          </FieldsContainer>
        </SectionContent>
      </Accordion.Item>
    </Accordion>
  );
};

export default BankDetails;
